<template>
  <div v-if = 'bannerInfo' class = 'banner' :style = '{backgroundImage: "url(" + bannerInfo.pic + ")"}'>
    <div class = 'banner_info'>
      <div class = 'PlayfairDisplay-Bold'>{{bannerInfo.title_EN}}</div>
      <div class = 'os-regular'>{{bannerInfo.inc_EN}}</div>
      <template v-if = 'false'>
        <div class = 'PlayfairDisplay-Bold'>{{bannerInfo["title_" + lang]}}</div>
        <div class = 'os-regular'>{{bannerInfo["inc_" + lang]}}</div>
      </template>

    </div>
  </div>
</template>
<script>
  export default {
    props: {
      bannerInfo: {
        type: Object,
        default: () => {
          return null
        }
      }
    },
    computed: {
      lang () {
        return this.$store.getters.getStoreLang;
      }
    }
  }
</script>
<style lang = 'scss' scoped>
  .banner{
    height: 540px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    background-color: #000;
    .banner_info{
      position: absolute;
      width: 100%;
      height: 100%;
      color: #fff;
      font-size: 16px;
      letter-spacing: 1px;
      line-height: 22px;
      text-align: center; 
      /**禁止文字选择 */
      user-select: none;
      -ms-user-select: none;
      -moz-user-select: -moz-none;
      -khtml-user-select: none;
      -webkit-user-select: none;
      div:first-child{
        font-size: 76px;
        line-height: 101px;
        margin-top: 267px;
      }
    }
  }
  .webapp .banner{
    height: 5.40rem;
    .banner_info{
      font-size: 0.24rem;
      line-height: 0.24rem;
      div:first-child{
        font-size: 0.76rem;
        line-height: 1.0rem;
        margin-top: 2rem;
      }
      div:last-child{
        margin-top: 0.3rem;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/common/bannerBg.vue